import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TuileButtonProps } from '../larged-tuile/larged-tuile.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-small-tuile',
  templateUrl: './small-tuile.component.html',
  styleUrls: ['./small-tuile.component.scss'],
  standalone: true,
  imports: [TranslatePipe],
})
export class SmallTuileComponent {
  @Input() type: 'icon' | 'text' | 'iconText' = 'icon';
  @Input() icon: string = '';
  @Input() title: string = '';

  @Input() content: any = null;

  @Input() color: string = '';

  @Input() mode: string | null = null;
  @Input() modeColor: string = '';
  @Input() status: string | null = null;

  @Input() statusMode: 'active' | 'inactive' | 'alarm' | null = null;
  @Input() disableBottom: boolean = false;

  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onPress = new EventEmitter<any>();

  getBackgroundColorFromColor() {
    if (this.color === 'color-red') {
      return '#ec1e0d66';
    } else if (this.color === 'color-green') {
      return '#85ec0d66';
    } else if (this.color === 'color-orange') {
      return '#f3920066';
    }

    return '';
  }

  constructor() {}

  onClickOnElement() {
    this.onPress.emit();
  }
}
